import { useState } from "react";
import CustomInput from "../../shared/CustomInput";
import { X } from "lucide-react";

const DisbursePhone = ({
  closeDisbursePhone,
  handleReviewDisburseDetails,
  disburseDetails,
  setDisburseDetails,
}) => {
  const [error, setError] = useState("");

  const handlePhoneChange = (e) => {
    const phone = e.target.value;

    setDisburseDetails({
      ...disburseDetails,
      phoneNumber: phone,
    });
    if (!/^07\d{8}$/.test(phone)) {
      setError("Enter a valid phone number (e.g., 0712345678).");
    } else {
      setError("");
    }
  };

  const handleNext = () => {
    if (!disburseDetails.phoneNumber || error) {
      setError("Please provide a valid phone number.");
      return;
    }
    handleReviewDisburseDetails();
  };
  return (
    <div
      onClick={closeDisbursePhone}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[500px] rounded-[10px] py-[20px] px-[40px] relative bg-white"
      >
        {/* Close Button */}
        <div
          onClick={closeDisbursePhone}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>

        {/* Title & Description */}
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Confirm M-PESA Phone Number
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Verify the recipient's account details before disbursing funds.
            Ensure accuracy to prevent errors or delays. Check that Account Name
            matches with the member’s name. DO NOT DISBURSE FUNDS IF THE ACCOUNT
            NAME DOES NOT MATCH WITH THE MEMBER’S NAME.
          </p>

          {/* Phone Input */}
          <div className="flex my-[20px] w-[100%] flex-col">
            <label
              className="text-[#222222] font-medium text-[13px]"
              htmlFor="M-PESA Phone Number"
            >
              M-PESA Phone Number
            </label>
            <CustomInput
              placeholder="e.g 0710 000 000"
              type="text"
              value={disburseDetails.phoneNumber || ""}
              onChange={handlePhoneChange}
            />
            {error && (
              <span className="text-red-500 text-[12px] mt-1">{error}</span>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="absolute bottom-[20px] left-[20px] right-[20px] flex items-center justify-between">
          <button
            onClick={closeDisbursePhone}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#222222] font-medium"
          >
            Back
          </button>
          <div className="flex items-center justify-center gap-[10px]">
            <button
              onClick={closeDisbursePhone}
              className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
            >
              Cancel
            </button>
            <button
              onClick={handleNext}
              disabled={!!error || !disburseDetails.phoneNumber}
              className={`h-[35px] rounded-[30px] px-[15px] font-medium text-white ${
                error || !disburseDetails.phoneNumber
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#000000] hover:bg-[#004080]"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisbursePhone;
